// bitmedia Ad Unit IDs ===============================================
// export const GameRoomAdUnitId = '68824c5ccd78b050d770cf3a' <--old
export const GameRoomAdUnitId = '6895fe31642cb1d670bd3bad'
export const SidebarAdUnitId = '68825412cd78b050d770ec9d'
export const OverviewAdUnitId = '688254d1cd78b050d770edd4'
export const ParticipantsAdUnitId = '6882556fcd78b050d770ef95' // <--old
// export const ParticipantsAdUnitId = '6895ff8338498fd61582f955'
export const SaveLineupAdUnitId = '68825791cd78b050d770f5fc'
export const EditLineupAdUnitId = '688258fdf6b31129f043ce99'
export const JoinConfirmationAdUnitId = '6882586ccd78b050d770f7e6'

// A-Ads ad unit ids ====================================================
export const AAds = {
  GameRoomsAdUnitId: '2407432',
  SidebarAdUnitId: '2407433',
  OverviewAdUnitId: '2407434',
  ParticipantsAdUnitId: '2407435',
  SaveLineupAdUnitId: '2407436',
  EditLineupAdUnitId: '2407437',
  JoinConfirmationAdUnitId: '2407438',
}
